import { Component, signal, WritableSignal } from '@angular/core';
import { BlockGaugeChart } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-gauge-chart',
  templateUrl: './block-gaugeChart.component.html',
})
export class BlockGaugeChartComponent extends BlockAbstractComponent<BlockGaugeChart, null> {
  public max: WritableSignal<number> = signal(100);
  public min: WritableSignal<number> = signal(0);
  public value: WritableSignal<number> = signal(0);

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(block: BlockGaugeChart): void {
    const maxAsNumber: number = +block.data.gauge.max;
    if (!Number.isNaN(maxAsNumber)) {
      this.max.set(maxAsNumber);
    }

    const minAsNumber: number = +block.data.gauge.min;
    if (!Number.isNaN(minAsNumber)) {
      this.min.set(minAsNumber);
    }

    const valueAsNumber: number = +block.data.gauge.value;
    if (!Number.isNaN(valueAsNumber)) {
      this.value.set(valueAsNumber);
    }
  }
}
